import { VFlow } from 'bold-ui'
import { resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoIndicatorResultado } from '../../components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '../../components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '../../components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '../../components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '../../components/PerguntaSimNaoRadioGroupBoxField'
import { isPerguntaStatusRespondendo } from '../../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { useConsultaSeguimentoSetResultado } from '../../hooks/useConsultaSeguimentoSetResultado'
import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'
import { calculateResultadoPergunta13, conditionToCalculatePergunta13 } from './utils-consultaSeguimentoPergunta13'

interface ConsultaSeguimentoPergunta13FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta13Model>
}

export function ConsultaSeguimentoPergunta13Field(props: Readonly<ConsultaSeguimentoPergunta13FieldProps>) {
  const { name } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta13Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta13Model>({
    name,
    conditionToCalculate: conditionToCalculatePergunta13,
    calculateResultado: calculateResultadoPergunta13,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        {isPerguntaStatusRespondendo(value.status) && (
          <ConsultaSeguimentoPerguntaHeader
            pergunta={MChatPerguntaEnum.PERGUNTA_13}
            title={<ConsultaSeguimentoPerguntaHeaderTitle sufix=' anda?' />}
            status={value.status}
            field={<SimNaoSwitchButtonField name={name.PERGUNTA_13_HEADER} />}
          />
        )}
        {value?.PERGUNTA_13_HEADER === SimNaoEnum.SIM && (
          <VFlow vSpacing={0}>
            <ConsultaSeguimentoIndicatorStart />
            <PerguntaSimNaoRadioGroupBoxField
              name={name.PERGUNTA_13_ANDA_SEM_APOIO}
              label='Anda sem se segurar ou sem se apoiar em algo?'
              required
            />
          </VFlow>
        )}
      </VFlow>
      {value?.resultado && <ConsultaSeguimentoIndicatorResultado resultado={value.resultado} />}
    </VFlow>
  )
}
